import React from 'react'
import { Button } from '../common'
import { Link, NavLink, useNavigate } from 'react-router-dom'
import GlemoLogo from '../../assets/glemo-logo.webp'
import { HeaderLinks, SearchBar } from '..'
import clsx from 'clsx'
import { useAuth } from '../../hooks/useAuth'
import { Suspense, memo, useEffect, useState } from 'react'
import SkeletonLoading from '../common/SkeletonLoading'
import UserLoginIcon from '../../assets/icons/blue-user.svg'
import SectionFilter from '../Sections/SectionFilter'

interface Props{
  isFixed?: boolean
}
function Header({isFixed = true}:Props) {
  // const navigate = usewindow.location.href = ()
  const auth = useAuth()
  const [authenticated, setAuthenticated] = useState<boolean>()

  useEffect(() => {
    setAuthenticated(auth.authenticated)
  }, [auth])

  return (
    <header
      className={clsx(
        // 'desktop-header header w-full h-[148px] pt-2 top-0 pb-20 bg-off-white border-b border-gray-300 items-center justify-center z-[99] hidden md:block fixed'
        'desktop-header header w-full pt-2 top-0 pb-5 bg-off-white border-b border-gray-300 items-center justify-center z-[99] hidden lg:block',
        {
          'relative':!isFixed,
        'fixed' : isFixed
        }
      )}
    >
      <div className="h-full w-full text-2xl flex flex-col justify-between m-auto">
        <div className="w-full flex items-center gap-4 px-5 lg:px-10">
          <span className="min-w-[129px] min-h-[78px] flex place-items-center">
            <a href="/">
              <Suspense fallback={<SkeletonLoading />}>
                <img
                  alt="Glemo Logo"
                  className="m-auto w-[129px] h-[47px]"
                  src={GlemoLogo}
                  width={129}
                  height={47}
                />
              </Suspense>
            </a>
          </span>

          <SearchBar />
          <Button
            variant="transparent"
            id="headerNavVisualizados"
            onClick={() => window.location.href = ('/visualizados')}
          >
            <div className="text-gray-700 px-0 py-0 hover:bg-gray-100 flex justify-center items-center gap-2.5 rounded transition-colors ease-in-out duration-250">
              <span className="bg-gray-100 text-blue-700 rounded px-4 py-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  width="20"
                  viewBox="0 0 256 256"
                >
                  <path d="M136,80v43.47l36.12,21.67a8,8,0,0,1-8.24,13.72l-40-24A8,8,0,0,1,120,128V80a8,8,0,0,1,16,0Zm-8-48A95.44,95.44,0,0,0,60.08,60.15C52.81,67.51,46.35,74.59,40,82V64a8,8,0,0,0-16,0v40a8,8,0,0,0,8,8H72a8,8,0,0,0,0-16H49c7.15-8.42,14.27-16.35,22.39-24.57a80,80,0,1,1,1.66,114.75,8,8,0,1,0-11,11.64A96,96,0,1,0,128,32Z"></path>
                </svg>
              </span>
              <span className="font-semibold tracking-wider pr-4 md:hidden lg:inline-block">
                Visualizados
              </span>
            </div>
          </Button>

          <Button
            variant="transparent"
            id="headerNavFavoritos"
            onClick={() => window.location.href = ('/favoritos')}
          >
            <div className="text-gray-700 px-0 py-0 hover:bg-gray-100 flex justify-center items-center gap-2.5 rounded transition-colors ease-in-out duration-250">
              <span className="bg-gray-100 text-blue-700 rounded px-4 py-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  fill="currentColor"
                  viewBox="0 0 256 256"
                >
                  <path d="M178,32c-20.65,0-38.73,8.88-50,23.89C116.73,40.88,98.65,32,78,32A62.07,62.07,0,0,0,16,94c0,70,103.79,126.66,108.21,129a8,8,0,0,0,7.58,0C136.21,220.66,240,164,240,94A62.07,62.07,0,0,0,178,32ZM128,206.8C109.74,196.16,32,147.69,32,94A46.06,46.06,0,0,1,78,48c19.45,0,35.78,10.36,42.6,27a8,8,0,0,0,14.8,0c6.82-16.67,23.15-27,42.6-27a46.06,46.06,0,0,1,46,46C224,147.61,146.24,196.15,128,206.8Z"></path>
                </svg>
              </span>
              <span className="font-semibold tracking-wider pr-4 md:hidden lg:inline-block">
                Favoritos
              </span>
            </div>
          </Button>

          {authenticated ? (
            <>
              <Button
                variant="orange"
                id="headerNavDadosCadastrais"
                className="w-[300px] rounded-full md:text-base lg:text-sm xl:text-lg"
                onClick={() => {
                  window.location.href = '/perfil/dados-cadastrais'
                }}
              >
                MINHA CONTA
              </Button>
            </>
          ) : (
            <a href="/entrar">
              <span className="text-blue-700 flex text-lg font-semibold tracking-wider">
                <span className="me-2 inline-block">Entrar</span>
                <img
                  src={UserLoginIcon}
                  width={20}
                  alt="User Icon"
                  className="m-auto inline-block"
                />
              </span>
            </a>
          )}
        </div>
        <SectionFilter />
        <hr className="my-4 opacity-[0.2]" />
        <HeaderLinks />
      </div>
    </header>
  )
}

export default memo(Header)
